import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { Constants } from 'src/app/helpers/constant';
import { ClaimsAddress } from 'src/app/model/client-info.interface';
import {KEY_DEFAULT_ERROR} from '../../../model/error.model';
@Component({
  selector: 'app-consent-scopes',
  templateUrl: './consent-scopes.component.html',
  styleUrls: ['./consent-scopes.component.scss'],
})
export class ConsentScopesComponent implements OnInit {
  scopes!: string[];
  buttonOptions: any = {
    accept: {
      color: 'accent',
      text: 'CONSENT_PREVIEW.ACCEPT',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  }

  errorMessage: string = '';
  consentClaims: any[] = []
  optionalClaims: any[] = []
  validationType: string = ''
  selectedItemsList: any = [];
  claimsConsent: boolean = false
  scopesConsent: boolean = false
  step: number = -1;
  showScopes: boolean = true;
  scopesConsents: any = []
  claim_values: any;
  claimsAddress!: ClaimsAddress;
  constants: typeof Constants | undefined;
  contentLoading: boolean = false;
  submissionInProgress = false;

  constructor(
    private route: ActivatedRoute,
    private cidaas: CidaasService,
    public commonFunc: CommonFunctionsService,
    private _cidaasSDK: CidaasService
  ) { }

  ngOnInit(): void {
    this.getScopeConsentDetails().then((res)=>{
    }).catch((err)=>{
    })
    this.constants = Constants
  }

  async getScopeConsentDetails(): Promise<void> {
    this.contentLoading = true;
    const resp = await this.cidaas._get()?.getScopeConsentDetails({
      track_id: this.route.snapshot.queryParams['track_id'],
      locale: navigator.language,
      requestId: this.route.snapshot.queryParams['requestId'],
    });
    this.contentLoading = false;
    if (resp && resp?.data && resp?.data?.meta_data) {
      /**
       * fix:[1350](https://gitlab.widas.de/cidaas-v2/framework/issues/-/issues/1350)
       * adding validation_type to the variable for future use
       *
       * */
      this.validationType = resp.data.validation_type;

      if(resp.data.meta_data.scopes == undefined) {
        this.claimsConsent = true
        this.claim_values = resp.data.meta_data.claims_values
        this.selectedItemsList = resp.data.meta_data.required_claims
        if(resp.data.meta_data.claims_values.address != undefined){
          this.claimsAddress = resp.data.meta_data.claims_values.address
        }
        resp.data.meta_data.required_claims.forEach((value) => {
          var obj: any = {};
          obj.claims = value
          obj.name = value
          obj.status = false
          this.consentClaims.push(obj)
        });
        let temp_optional: any = []
        resp.data.meta_data.optional_claims.forEach((value) => {
          var obj: any = {};
          obj.claims = value
          obj.name = value
          obj.status = true
          this.consentClaims.push(obj)
        });
        this.optionalClaims = temp_optional
      } else {
        this.scopesConsent = true
        this.selectedItemsList = resp.data.meta_data.scopes
        resp.data.meta_data.scopes.forEach((value) => {
          let obj = {}
          obj[value.scope] = "granted"
          obj['status'] = false
          obj['scope'] = value.scope
          obj['description'] = value.description
          this.scopesConsents.push(obj)
        });
      }
      this._getRegistrationFields();
    }
    if (resp.error) {
      this.errorMessage = KEY_DEFAULT_ERROR;
    }
  }

  // Start

  changeSelection(option:string,checked:boolean)
  {
     if (checked && this.selectedItemsList.indexOf(option)<0)
     {
         this.selectedItemsList=[...this.selectedItemsList,option]
         .sort((a,b)=>this.selectedItemsList.indexOf(a)>this.selectedItemsList.indexOf(b)?1:-1)
     }
    if (!checked)
          this.selectedItemsList=this.selectedItemsList.filter(x=>x!=option)
  }

  scopeSelection(index_value: any, value: boolean) {
    let obj: any = {}
    if(value) {
      let index_number = this.scopesConsents.findIndex(x => x[index_value] ==="denied");
      this.scopesConsents[index_number][index_value] = "granted"
    } else {
      let index_number = this.scopesConsents.findIndex(x => x[index_value] ==="granted");
      this.scopesConsents[index_number][index_value] = "denied"
    }
  }

  _getRegistrationFields = (): void => {
    let options = {
      acceptlanguage: navigator.language,
      requestId: this.route.snapshot.queryParams['requestId'],
    };

    this.contentLoading = true;
    this._cidaasSDK
      ._getRegistrationSetup(options)
      .then((response: any) => {
        this.contentLoading = false;
        if (response && response.data) {
          this.contentLoading = true;
          // matching locale names for the object keys
          let temp : any = []
          for(let i=0; i< this.consentClaims.length; i++) {
            var obj: any = {};
            for(let j=0; j< response.data.length; j++) {
              if (this.consentClaims[i]['claims'] == response.data[j].fieldKey) {
                obj.claims = this.consentClaims[i]['claims']
                obj.name = response.data[j].localeText.name
                obj.status = false
                temp.push(obj)
                break
              } else if (j ==  response.data.length){
                obj.claims = this.consentClaims[i]['claims']
                obj.name = this.consentClaims[i]['claims']
                obj.status = false
                temp.push(obj)
                break
              }
            }
          }
          for(let i=0; i< this.consentClaims.length; i++) {
            for(let j=0; j< temp.length; j++) {
              if (this.consentClaims[i]['claims'] == temp[j]['claims']) {
                let objIndex = this.consentClaims.findIndex((obj => obj.claims == temp[j]['claims']));
                this.consentClaims[objIndex].name = temp[j]['name']
              } else {
                this.consentClaims[i].name == this.consentClaims[i]['claims']
              }
            }
          }
          this.contentLoading = false;
        } else {
          this.errorMessage = KEY_DEFAULT_ERROR;
        }
      })
      .catch((error) => {
        this.errorMessage = KEY_DEFAULT_ERROR;
      });
  };
  // End

  async acceptScopeConsent(): Promise<void> {
    let scopesArray = [ ...this.scopesConsents ];
    scopesArray.forEach(function(v){ delete v.status; delete v.scope; delete v.description });
    this.submissionInProgress = true;
    if (this.validationType == Constants.CONSENT_CLAIMS) {
      const resp = await this.cidaas._get().acceptClaimConsent({
        q: this.route.snapshot.queryParams['sub'],
        client_id: this.route.snapshot.queryParams['client_id'],
        accepted_claims: this.selectedItemsList,
      });
      await this.claimConsentContinue();
    } else if (this.validationType == Constants.CONSENT_SCOPES) {
      const resp = await this.cidaas._get().acceptScopeConsent({
        sub: this.route.snapshot.queryParams['sub'],
        client_id: this.route.snapshot.queryParams['client_id'],
        scopes: scopesArray
      });
      await this.scopeConsentContinue();
    }
    this.submissionInProgress = false;
  }

  async scopeConsentContinue(): Promise<void> {
    const resp = await this.cidaas._get().scopeConsentContinue({
      sub: this.route.snapshot.queryParams['sub'],
      client_id: this.route.snapshot.queryParams['client_id'],
      track_id: this.route.snapshot.queryParams['track_id'],
    });
  }
  // start claims api

  async claimConsentContinue(): Promise<void> {
    const resp = await this.cidaas._get().scopeConsentContinue({
      sub: this.route.snapshot.queryParams['sub'],
        client_id: this.route.snapshot.queryParams['client_id'],
      track_id: this.route.snapshot.queryParams['track_id'],
    });
  }

  // end claims api

  _showFields = (index) => {
    this.showScopes = false;
    // let allowedFields = this.consentScopes[index]['allowed_fields'];
    // this.scopeName = this.consentScopes[index]['scope'];
    this.step = index;
    // this.allowedFields = allowedFields.filter(item => !this.requiredFields.includes(item));

  };
}
